export const COMMENT = 'COMMENT';
export const DEEP_COMMENT = 'DEEP_COMMENT';
export const REPLY = 'REPLY';
export const ENGAGEMENT = 'ENGAGEMENT';
export const REPLACE = 'replace';
export const REMOVE = 'remove';
export const MESSAGE = '/message';
export const META_DESCRIPTION = '/metaDescription';
export const AT_MENTIONED_USER_IDS = '/atMentionedUserIds';

// need to have separate object for every path that we want to update within a comment